export function GovernEditorActions(props: { onCancel: () => void }) {
  return (
    <div class="govern-editor-actions">
      <button type="button" onClick={props.onCancel}>
        Cancel
      </button>
      <button type="submit" class="govern-primary-action">
        Apply preview change
      </button>
    </div>
  );
}
